import React, { useState, useEffect } from "react";
import { pb4y } from "../../../../services/apis";
import { Loader } from "semantic-ui-react";
import { datePattern } from "../../../../utils/Utils";
import {
  Container,
  Content,
  ContentNumbersBox,
  NumbersBox,
  SemanticTable,
  ContainerInputSearch,
  Input,
  ContentHeaderMinusFive,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { getToken, isAuthAdmin } from "../../../../services/auth";
import { Box } from "@material-ui/core";

const Nominations = () => {
  const [search, setSearch] = useState("");
  const [nominations, setNominations] = useState({});
  const [specific, setSpecific] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    pb4y
      .get("admin/nominations", {
        headers: {
          access_token: `voitto-token ${getToken()}`,
        },
      })
      .then(res => {
        setNominations(res.data);
        setLoading(false);
      })
      .catch(err => console.error(err));
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const searchSpecific = () => {
    pb4y
      .get(`admin/specific-nominations?search=${search}`, {
        headers: {
          access_token: `voitto-token ${getToken()}`,
        },
      })
      .then(res => {
        if (res.data.length <= 0) {
          swal(
            "Essa indicação não existe",
            "Faça a busca novamente",
            "warning"
          );
        }
        setSpecific(res.data);
      })
      .catch(err => console.error(err));
  };

  const handleKeyUp = e => {
    if (e.keyCode === 13) {
      searchSpecific();
    }
  };

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
        <AdminMenu />
        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <header>
              <ContentNumbersBox>
                <h2>5 Indicações</h2>
                <section>
                  <NumbersBox color="#333">
                    <p>Total</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.total.five}</p>
                    </strong>
                  </NumbersBox>
                  <NumbersBox color="#28a745">
                    <p>Aceitas</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.accept.five}</p>
                    </strong>
                  </NumbersBox>
                </section>
              </ContentNumbersBox>
              <ContentNumbersBox>
                <h2>20 Indicações</h2>
                <section>
                  <NumbersBox color="#333">
                    <p>Total</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.total.twenty}</p>
                    </strong>
                  </NumbersBox>
                  <NumbersBox color="#28a745">
                    <p>Aceitas</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.accept.twenty}</p>
                    </strong>
                  </NumbersBox>
                </section>
              </ContentNumbersBox>
              <ContentNumbersBox>
                <h2>50 Indicações</h2>
                <section>
                  <NumbersBox color="#333">
                    <p>Total</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.total.fifty}</p>
                    </strong>
                  </NumbersBox>
                  <NumbersBox color="#28a745">
                    <p>Aceitas</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.accept.fifty}</p>
                    </strong>
                  </NumbersBox>
                </section>
              </ContentNumbersBox>
              <ContentNumbersBox>
                <h2>100 Indicações</h2>
                <section>
                  <NumbersBox color="#333">
                    <p>Total</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.total.oneHundred}</p>
                    </strong>
                  </NumbersBox>
                  <NumbersBox color="#28a745">
                    <p>Aceitas</p>
                    <strong>
                      <p>{nominations.totalBasedOnResult.accept.oneHundred}</p>
                    </strong>
                  </NumbersBox>
                </section>
              </ContentNumbersBox>
            </header>
            <ContentHeaderMinusFive>
              <section>
                <h1>Número total de indicações:</h1>
                <strong>{nominations.totalNominations.count}</strong>
              </section>
              <section>
                <h1>Número total de Usuários:</h1>
                <strong>{nominations.totalUsers}</strong>
              </section>
              <section>
                <h1>N° de usuários com menos de 5 indicações:</h1>
                <strong>
                  {nominations.totalBasedOnResult.total.minusFive}
                </strong>
              </section>
              <section>
                <h1>N° de usuários com menos de 5 indicações aceitas:</h1>
                <strong>
                  {nominations.totalBasedOnResult.accept.minusFive}
                </strong>
              </section>
            </ContentHeaderMinusFive>
            <main>
              <h1>Tabela de últimas indicações</h1>
              <ContainerInputSearch>
                <Input
                  type="text"
                  placeholder="Pesquise pelo email do participante"
                  onChange={e => {
                    setSpecific([]);
                    setSearch(e.target.value);
                  }}
                  onKeyUp={e => handleKeyUp(e)}
                />
              </ContainerInputSearch>
              <SemanticTable size="big" celled>
                <SemanticTable.Header>
                  <SemanticTable.Row>
                    <SemanticTable.HeaderCell style={{ width: "10%" }}>
                      Nome do participante
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "20%" }}>
                      Email do participante
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "50%" }}>
                      Email indicado pelo participante
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "10%" }}>
                      Registro
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell style={{ width: "5%" }}>
                      Status
                    </SemanticTable.HeaderCell>
                  </SemanticTable.Row>
                </SemanticTable.Header>
                <SemanticTable.Body>
                  {!specific.length
                    ? nominations.totalNominations?.rows
                        .filter(valor =>
                          valor.email_user
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((elem, index) => (
                          <SemanticTable.Row key={index}>
                            <SemanticTable.Cell>
                              {elem.name_user}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.email_user}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.email_destino}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.data_sys)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.status === 0 ? "Pendente" : "Aceito"}
                            </SemanticTable.Cell>
                          </SemanticTable.Row>
                        ))
                    : specific
                        .filter(valor =>
                          valor.email_destino
                            .toLowerCase()
                            .includes(search.toLowerCase())
                        )
                        .map((elem, index) => (
                          <SemanticTable.Row key={index}>
                            <SemanticTable.Cell>
                              {elem.name_user}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.email_user}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.email_destino}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {datePattern(elem.data_sys)}
                            </SemanticTable.Cell>
                            <SemanticTable.Cell>
                              {elem.status === 0 ? "Pendente" : "Aceito"}
                            </SemanticTable.Cell>
                          </SemanticTable.Row>
                        ))}
                </SemanticTable.Body>
              </SemanticTable>
            </main>
          </Content>
        )}
        ;
      </Box>
    </Box>
  );
};

export default withRouter(Nominations);
